import React from 'react';
import SVG from 'react-inlinesvg';

import { FAVORITE_ICON_PATH } from 'consts';
import { useAppStore } from 'hooks';
import { getFavoriteChannelIcon } from 'utils';

interface Props {
  className?: string;
  isPurchasable: boolean | undefined;
  linearId: number;
  presentOnRail: boolean;
}

export function FavoriteIcon({ className = '', isPurchasable, linearId, presentOnRail }: Props) {
  const {
    appStore: { staticAssetsUrl, favoriteRepository },
  } = useAppStore();

  const isFavorite = !!favoriteRepository.getFavorite(linearId);
  const isShowFavorite = isFavorite && !isPurchasable && presentOnRail;

  if (!isShowFavorite) {
    return null;
  }

  return (
    <SVG
      className={className}
      data-type='favorite'
      src={`${staticAssetsUrl}${getFavoriteChannelIcon(FAVORITE_ICON_PATH)}`}
    />
  );
}
